import CustomInput from 'src/componentes/CustomInput';

function Checkbox({ type = 'checkbox', ...rest }) {
  return <CustomInput type={type} {...rest} />;
}

export default Checkbox;
